import type { ConversationBrand } from "@/lib/api";

/**
 * The brands a conversation can be pinned to, in the same order as the backend
 * enum (and the brand picker) so the switcher reads consistently.
 */
export const CONVERSATION_BRANDS: readonly ConversationBrand[] = ["Wheelabrator", "DISA"];

/**
 * Narrow an arbitrary string to a known brand.
 *
 * Two callers need this: the API returns `brand` as a plain `string` on
 * conversation summaries/details (the literal union only exists on the
 * create-conversation request), and the `?brand=` query param on bare `/chat`
 * is user-editable. Anything unrecognised becomes `null`, which the chat page
 * treats as "no brand context" (unfiltered list, no switcher) rather than
 * trusting a bogus value.
 */
export function asConversationBrand(value: string | null | undefined): ConversationBrand | null {
  return CONVERSATION_BRANDS.find((brand) => brand === value) ?? null;
}

/**
 * Path of the brand-scoped, conversation-less chat view. Used when switching
 * brands and after deleting the open conversation — both land the technician in
 * the other/current brand's context with nothing selected.
 */
export function brandChatPath(brand: ConversationBrand): string {
  return `/chat?brand=${encodeURIComponent(brand)}`;
}
